export default "__VITE_ASSET__1722bcc9__"